import React from "react";
import { Box } from "@mui/material";

interface ProfileStepDotsProps {
  currentPage: number;
  onGoToPage?: (page: number) => void;
}

const ProfileStepDots: React.FC<ProfileStepDotsProps> = ({
  currentPage,
  onGoToPage,
}) => {
  return (
    <Box display="flex" gap={2}>
      {[1, 2, 3, 4].map((step) => (
        <Box
          key={step}
          onClick={() => onGoToPage?.(step)}
          sx={{
            width: 36,
            height: 8,
            borderRadius: 4,
            bgcolor: step <= currentPage ? "#84E1CC" : "#DFF4EF",
            cursor: onGoToPage ? "pointer" : "default",
            transition: "background-color 0.2s ease",
            "&:hover": onGoToPage
              ? { bgcolor: step <= currentPage ? "#6fd4bc" : "#c8ebe3" }
              : undefined,
          }}
        />
      ))}
    </Box>
  );
};

export default ProfileStepDots;
